const assetsManager = {
  init({ atlas, lib, ss }) {
    return new Promise((resolve) => {
      this.loader = new createjs.LoadQueue();
      this.loader.addEventListener('complete', () => {
        this.createSpriteSheets(lib, ss);
        resolve();
      });
      this.loader.loadFile({
        src: atlas,
        id: 'maket_atlas_',
      });
    });
  },

  createSpriteSheets(lib, ss) {
    lib.ssMetadata.forEach((item) => {
      /* eslint-disable no-param-reassign */
      ss[item.name] = new createjs.SpriteSheet({
        images: [this.loader.getResult(item.name)],
        frames: item.frames,
      });
      /* eslint-enable no-param-reassign */
    });
  },
};

export default assetsManager;



// WEBPACK FOOTER //
// ../base/js/managers/assets.js